import { createAction, props } from '@ngrx/store';
import { TicketHistoryFilterState } from '../ticket-history.model';

export const initHistoryTicketSearchFilter = createAction('[Ticket History]: Init');
export const updateTicketHistorySearchFilter = createAction(
    '[Ticket History]: Update Search Filter',
    props<{ payload: TicketHistoryFilterState }>()
);
export const resetTicketHistorySearchFilter = createAction('[Ticket History]: Reset Search Filter');
